import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import NewRequest from "./pages/NewRequest";
import RequestDetail from "./pages/RequestDetail";
import Matches from "./pages/Matches";
import Missions from "./pages/Missions";
import EnCours from "./pages/EnCours";
import TrajetsDisponibles from "./pages/TrajetsDisponibles";
import Support from "./pages/Support";
import AdminSupport from "./pages/AdminSupport";
import OffersPage from "./pages/OffersPage";
import Rentabilite from "./pages/Rentabilite";
import ProConformite from "./pages/ProConformite";
import ProReturnTrips from "./pages/ProReturnTrips";
import AdminDocuments from "./pages/AdminDocuments";
import AdminDisputes from "./pages/AdminDisputes";
import AdminKpis from "./pages/AdminKpis";
import Reviews from "./pages/Reviews";
import Notifications from "./pages/Notifications";
import PaymentSuccess from "./pages/PaymentSuccess";
import Avis from "./pages/Avis";
import NotFound from "./pages/NotFound";
import MentionsLegales from "./pages/legal/MentionsLegales";
import CGU from "./pages/legal/CGU";
import CGV from "./pages/legal/CGV";
import Confidentialite from "./pages/legal/Confidentialite";
import Cookies from "./pages/legal/Cookies";

// Handles race where Google OAuth returns with session_id in URL hash on any route.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/avis" element={<Avis />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/cgu" element={<CGU />} />
      <Route path="/cgv" element={<CGV />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/onboarding" element={
        <ProtectedRoute><Onboarding /></ProtectedRoute>
      } />

      <Route path="/dashboard" element={
        <ProtectedRoute><Dashboard /></ProtectedRoute>
      } />
      <Route path="/requests" element={
        <ProtectedRoute><Dashboard /></ProtectedRoute>
      } />
      <Route path="/requests/new" element={
        <ProtectedRoute roles={["client", "admin"]}><NewRequest /></ProtectedRoute>
      } />
      <Route path="/requests/:id" element={
        <ProtectedRoute><RequestDetail /></ProtectedRoute>
      } />
      <Route path="/missions" element={
        <ProtectedRoute roles={["pro", "admin"]}><Missions /></ProtectedRoute>
      } />
      <Route path="/en-cours" element={
        <ProtectedRoute><EnCours /></ProtectedRoute>
      } />
      <Route path="/trajets-disponibles" element={
        <ProtectedRoute><TrajetsDisponibles /></ProtectedRoute>
      } />
      <Route path="/matches" element={
        <ProtectedRoute roles={["pro", "admin"]}><Matches /></ProtectedRoute>
      } />
      <Route path="/offers" element={
        <ProtectedRoute><OffersPage /></ProtectedRoute>
      } />
      <Route path="/rentabilite" element={
        <ProtectedRoute roles={["pro", "admin"]}><Rentabilite /></ProtectedRoute>
      } />
      {/* Réservées aux pros : le backend répond 403 aux admins sur ces APIs */}
      <Route path="/pro/conformite" element={
        <ProtectedRoute roles={["pro"]}><ProConformite /></ProtectedRoute>
      } />
      <Route path="/pro/trajets-retour" element={
        <ProtectedRoute roles={["pro"]}><ProReturnTrips /></ProtectedRoute>
      } />
      <Route path="/admin/documents" element={
        <ProtectedRoute roles={["admin"]}><AdminDocuments /></ProtectedRoute>
      } />
      <Route path="/admin/disputes" element={
        <ProtectedRoute roles={["admin"]}><AdminDisputes /></ProtectedRoute>
      } />
      <Route path="/admin/kpis" element={
        <ProtectedRoute roles={["admin"]}><AdminKpis /></ProtectedRoute>
      } />
      <Route path="/reviews" element={
        <ProtectedRoute roles={["pro", "admin"]}><Reviews /></ProtectedRoute>
      } />
      <Route path="/notifications" element={
        <ProtectedRoute><Notifications /></ProtectedRoute>
      } />
      <Route path="/payment/success" element={
        <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
      } />
      <Route path="/support" element={
        <ProtectedRoute><Support /></ProtectedRoute>
      } />
      <Route path="/admin/support" element={
        <ProtectedRoute roles={["admin"]}><AdminSupport /></ProtectedRoute>
      } />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
